// @ts-nocheck

import React from 'react';

import { ReactComponent as Athletics } from '../../assets/svg/sports/athletics.svg';
import { ReactComponent as Badminton } from '../../assets/svg/sports/badminton.svg';
import { ReactComponent as Bandy } from '../../assets/svg/sports/bandy.svg';
import { ReactComponent as Baseball } from '../../assets/svg/sports/baseball.svg';
import { ReactComponent as Basket } from '../../assets/svg/sports/basket.svg';
import { ReactComponent as Basketball3 } from '../../assets/svg/sports/basket3.svg';
import { ReactComponent as Beachsoccer } from '../../assets/svg/sports/beachsoccer.svg';
import { ReactComponent as BeachVolley } from '../../assets/svg/sports/beachvolley.svg';
import { ReactComponent as Boost } from '../../assets/svg/sports/boost.svg';
import { ReactComponent as Boulingrin } from '../../assets/svg/sports/boulingrin.svg';
import { ReactComponent as Boxe } from '../../assets/svg/sports/boxe.svg';
import { ReactComponent as Chess } from '../../assets/svg/sports/chess.svg';
import { ReactComponent as Cricket } from '../../assets/svg/sports/cricket.svg';
import { ReactComponent as Curling } from '../../assets/svg/sports/curling.svg';
import { ReactComponent as Cycling } from '../../assets/svg/sports/cycling.svg';
import { ReactComponent as Darts } from '../../assets/svg/sports/darts.svg';
import { ReactComponent as Esport } from '../../assets/svg/sports/esport.svg';
import { ReactComponent as Fallback } from '../../assets/svg/sports/fallback.svg';
import { ReactComponent as FieldHockey } from '../../assets/svg/sports/fieldhockey.svg';
import { ReactComponent as Floorball } from '../../assets/svg/sports/floorball.svg';
import { ReactComponent as Football } from '../../assets/svg/sports/football.svg';
import { ReactComponent as Footballaustralien } from '../../assets/svg/sports/footballaustralien.svg';
import { ReactComponent as Footballus } from '../../assets/svg/sports/footballus.svg';
import { ReactComponent as Futsal } from '../../assets/svg/sports/futsal.svg';
import { ReactComponent as Gaelicsport } from '../../assets/svg/sports/gaelicsport.svg';
import { ReactComponent as Golf } from '../../assets/svg/sports/golf.svg';
import { ReactComponent as Handball } from '../../assets/svg/sports/handball.svg';
import { ReactComponent as Icehockey } from '../../assets/svg/sports/icehockey.svg';
import { ReactComponent as Judo } from '../../assets/svg/sports/judo.svg';
import { ReactComponent as MMA } from '../../assets/svg/sports/mma.svg';
import { ReactComponent as Motorsport } from '../../assets/svg/sports/motorsport.svg';
import { ReactComponent as Netball } from '../../assets/svg/sports/netball.svg';
import { ReactComponent as Olympics } from '../../assets/svg/sports/olympics.svg';
import { ReactComponent as Padel } from '../../assets/svg/sports/padel.svg';
import { ReactComponent as Pesapallo } from '../../assets/svg/sports/pesapallo.svg';
import { ReactComponent as Petanque } from '../../assets/svg/sports/petanque.svg';
import { ReactComponent as Pool } from '../../assets/svg/sports/pool.svg';
import { ReactComponent as Rugby } from '../../assets/svg/sports/rugby.svg';
import { ReactComponent as Rugby13 } from '../../assets/svg/sports/rugby13.svg';
import { ReactComponent as Rugby7 } from '../../assets/svg/sports/rugby7.svg';
import { ReactComponent as Snooker } from '../../assets/svg/sports/snooker.svg';
import { ReactComponent as Squash } from '../../assets/svg/sports/squash.svg';
import { ReactComponent as Star } from '../../assets/svg/sports/star.svg';
import { ReactComponent as Surf } from '../../assets/svg/sports/surf.svg';
import { ReactComponent as Swimming } from '../../assets/svg/sports/swimming.svg';
import { ReactComponent as Tabletennis } from '../../assets/svg/sports/tabletennis.svg';
import { ReactComponent as Tennis } from '../../assets/svg/sports/tennis.svg';
import { ReactComponent as Voile } from '../../assets/svg/sports/voile.svg';
import { ReactComponent as Volleyball } from '../../assets/svg/sports/volleyball.svg';
import { ReactComponent as Waterpolo } from '../../assets/svg/sports/waterpolo.svg';
import { ReactComponent as Wintersports } from '../../assets/svg/sports/wintersports.svg';
import { SportIds } from '../../types/sports';

const Icons = {
  [SportIds.ATHLETICS]: Athletics,
  [SportIds.SOCCER]: Football,
  [SportIds.BADMINTON]: Badminton,
  [SportIds.BASEBALL]: Baseball,
  [SportIds.BASKETBALL]: Basket,
  [SportIds.BEACH_VOLLEY]: BeachVolley,
  [SportIds.BOXING]: Boxe,
  [SportIds.CURLING]: Curling,
  [SportIds.CYCLING]: Cycling,
  [SportIds.FIELD_HOCKEY]: FieldHockey,
  [SportIds.SOCCER]: Football,
  [SportIds.FOOTBALL]: Footballus,
  [SportIds.GOLF]: Golf,
  [SportIds.HANDBALL]: Handball,
  [SportIds.ICEHOCKEY]: Icehockey,
  [SportIds.JUDO]: Judo,
  [SportIds.MOTOR_SPORT]: Motorsport,
  [SportIds.OLYMPICS]: Olympics,
  [SportIds.PETANQUE]: Petanque,
  [SportIds.RUGBY]: Rugby,
  [SportIds.SNOOKER]: Snooker,
  [SportIds.SWIMMING]: Swimming,
  [SportIds.TABLE_TENNIS]: Tabletennis,
  [SportIds.TENNIS]: Tennis,
  [SportIds.SAILING]: Voile,
  [SportIds.VOLLEYBALL]: Volleyball,
  [SportIds.WATERPOLO]: Waterpolo,
  [SportIds.WINTER_SPORTS]: Wintersports,
  [SportIds.BANDY]: Bandy,
  [SportIds.BEACH_SOCCER]: Beachsoccer,
  [SportIds.BOWLS]: Boulingrin,
  [SportIds.CHESS]: Chess,
  [SportIds.CRICKET]: Cricket,
  [SportIds.DARTS]: Darts,
  [SportIds.ESPORT_COUNTER_STRIKE]: Esport,
  [SportIds.ESPORT_LEAGUE_OF_LEGENDS]: Esport,
  [SportIds.ESPORT_DOTA]: Esport,
  [SportIds.ESPORT_COD]: Esport,
  [SportIds.ESPORT_STREET_FIGHTER_V]: Esport,
  [SportIds.ESPORT_OVERWATCH]: Esport,
  [SportIds.FLOORBALL]: Floorball,
  [SportIds.AUSSIE_RULES]: Footballaustralien,
  [SportIds.FUTSAL]: Futsal,
  [SportIds.GAELICSPORT]: Gaelicsport,
  [SportIds.NETBALL]: Netball,
  [SportIds.PADEL]: Padel,
  [SportIds.PESAPALLO]: Pesapallo,
  [SportIds.POOL]: Pool,
  [SportIds.RUGBY_LEAGUE]: Rugby13,
  [SportIds.RUGBY_7S]: Rugby7,
  [SportIds.RUGBY_LEAGUE_OLD]: Rugby13,
  [SportIds.RUGBY_7S_OLD]: Rugby7,
  [SportIds.BASKETBALL_3]: Basketball3,
  [SportIds.SQUASH]: Squash,
  [SportIds.SURF]: Surf,
  [SportIds.SPECIAL_ODDS]: Boost,
  [SportIds.SPECIALS]: Star,
  [SportIds.SPECIALS__99999]: Star,
  [SportIds.MMA]: MMA,
};

const SportIcon = ({ sportId, ...rest }: unknown) => {
  if (sportId) {
    const IconComponent = Icons[sportId];

    if (IconComponent) {
      return <IconComponent {...rest} />;
    }
  }
  return <Fallback {...rest} />;
};

export default SportIcon;
